import QrCodeScannerRoundedIcon from "@mui/icons-material/QrCodeScannerRounded";
import { IconProps } from "./types";

export function ScanQrCodeIcon({ size, ...props }: IconProps) {
    return <QrCodeScannerRoundedIcon fontSize={size} {...props} />;
}
